import Author from './Author';
import Theme from './Theme';
import ToDoList from './ToDoList';

function App() {
  return (
  <>
    <Author/>
    <Theme />
    <ToDoList />
  </>
  );
}

export default App;
